const DEFAULT_AUTO_LOCALE = 'auto';
const DEFAULT_SOURCE_INFO = {};
const DEFAULT_TIMEOUT_POLICY = 'MEDIUM';
const DEFAULT_AB_TESTS = {};

const MT_CONTEXTS = {
    GENERAL: 'general',
    SEARCH: 'search',
    GIG_TITLE: 'gig_title'
};

module.exports = {
    DEFAULT_AUTO_LOCALE,
    DEFAULT_SOURCE_INFO,
    DEFAULT_TIMEOUT_POLICY,
    DEFAULT_AB_TESTS,
    MT_CONTEXTS
};
